import type { SelectedPath } from '../types';

export function isSelected(navPath: SelectedPath, menuId: string): boolean {
	return navPath.includes(menuId);
}
